import React from "react";

// Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { RegistrationStage } from "../../types";

const MemberStatus = (props: any) => {
  const { member, registrationStages } = props;
  const { t } = useTranslation();

  const stage: RegistrationStage = registrationStages.find((stage: RegistrationStage) => stage.id === member.registration_stage_id);

  let status;
  if (stage) {
    switch (stage.id) {
      case 1:
        status = { icon: ["fa-duotone", "fa-check"], text: t("registered"), color: "approved" };
        break;
    }
  }

  switch (member.status) {
    case "declined":
      status = { icon: ["far", "fa-circle-xmark"], text: t("declined"), color: "danger" };
      break;
    case "cancelled":
      status = { icon: ["far", "fa-trash-can"], text: t("cancelled"), color: "danger" };
      break;
    case "blocked":
      status = { icon: ["far", "fa-lock"], text: t("blocked"), color: "danger" };
      break;
    case "approved":
      status = { icon: ["far", "fa-circle-check"], text: t("approved") };
  }

  return (
    <div className={`member-status--${status?.color}`}>
      {/* @ts-ignore */}
      <FontAwesomeIcon icon={status?.icon || ["far", "question"]} />
      {status?.text}
    </div>
  );
};

export default MemberStatus;
